export function processInterviewDateTime(idt: string | any) {
    if (!idt) return { date: "", time: "" };
    let arr = idt.split("-");
    let time = arr.slice(-2).join("-");
    let date = arr.slice(0, -2).join("-");
    return { date, time };
}
